import { gql } from "@apollo/client";

export const GET_ALL_RECEIPTS = gql`
  query GetAllReceipts {
    getAllReceipts {
      receipt_id
      temple_id
      receipt_number
      receipt_date
       total_amount
      payment_mode
      payment_reference
      remarks
      receipt_image_url
      created_by_user_id
      created_at
        attachment_type
      
      file_url
  receipt_to_date
      gothram
      poojaCategory
      relationName
       devoteeName
       seva_type_id
       occasion
       from
       devoteeAddress
           phoneNumber
           status
            pooja_datetime
             additional_information
             abharana_name
    
     
    }
  }
`;

export const GET_ALL_RECEIPTS_WITH_PAGINATION = gql`
  query getAllReceiptsWithPagination($input: PaginationInput) {
    getAllReceiptsWithPagination(input: $input) {
      data {
        receipt_id
        temple_id
        receipt_number
        receipt_date
            total_amount
        payment_mode
        payment_reference
        remarks
        receipt_image_url
        created_by_user_id
        created_at
        attachment_type
           file_url
        receipt_to_date
        gothram
        poojaCategory
        relationName
        devoteeName
        seva_type_id
        occasion
        from
        devoteeAddress
        phoneNumber
        status
        pooja_datetime
        additional_information
        abharana_name
           }
      pagination {
        total
        page
        limit
        totalPages
      }
    }
  }
`;


export const GET_RECEIPT_BY_ID = gql`
  query GetReceiptById($receipt_id: ID!) {
    getReceiptById(receipt_id: $receipt_id) {
      receipt_id
      temple_id
      receipt_number
      receipt_date
      total_amount
      payment_mode
      payment_reference
      remarks
      receipt_image_url
      created_by_user_id
      created_at
        attachment_type
            file_url
      gothram
      poojaCategory
      relationName
       devoteeName
       seva_type_id
          occasion
       from
       devoteeAddress
       phoneNumber
       status
        pooja_datetime
        additional_information
        receipt_to_date
        abharana_name
    }
  }
`;

export const GET_RECEIPTS_BY_TEMPLE = gql`
  query GetReceiptsByTempleId($temple_id: ID!) {
    getReceiptsByTempleId(temple_id: $temple_id) {
      receipt_id
      receipt_number
      receipt_date
      receipt_to_date
         total_amount
      payment_mode
      created_at
        attachment_type
      file_url
         }
  }
`;


export const CREATE_RECEIPT = gql`
  mutation CreateReceipt($input: createReceiptInput) {
    createReceipt(input: $input) {
      receipt_id
      temple_id
      receipt_number
      receipt_date
      receipt_to_date
        total_amount
      payment_mode
      payment_reference
      remarks
      receipt_image_url
      created_by_user_id
      created_at
      attachment_type
      file_url
       gothram
      poojaCategory
      relationName
      devoteeName
      seva_type_id
      occasion
      from
      devoteeAddress
      phoneNumber
      status
      pooja_datetime
      additional_information
      abharana_name
    }
  }
`;


export const UPDATE_RECEIPT = gql`
  mutation UpdateReceipt($input: updateReceiptInput) {
    updateReceipt(input: $input) {
      receipt_id
      temple_id
      receipt_number
      receipt_date
        total_amount
      payment_mode
      payment_reference
      remarks
      receipt_image_url
      created_by_user_id
      created_at
        attachment_type
      file_url
       gothram
      poojaCategory
      relationName
       devoteeName
      seva_type_id
        occasion
       from
       devoteeAddress
       phoneNumber
       status
        pooja_datetime
        additional_information
        receipt_to_date
        abharana_name
    }
  }
`;


export const DELETE_RECEIPT = gql`
  mutation DeleteReceipt($receipt_id: ID!) {
    deleteReceipt(receipt_id: $receipt_id)
  }
`;

export const GET_SWASWATA_ANNAPRASADA_RECEIPTS = gql`
  query GetSwaswataAnnaprasadaReceipts {
    getSwaswataAnnaprasadaReceipts {
      receipt_id
      receipt_number
      receipt_date
      temple_id
      devoteeName
      relationName
      gothram
      phoneNumber
      devoteeAddress
      total_amount
      payment_mode
      poojaCategory
        occasion
      from
      pooja_datetime
    }
  }
`;